export default {
      id: "sli-face-id-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#sli-face-id",
      toString: function () {
        return this.url;
      }
    }